import React, { useEffect, useState } from 'react';
import { TCategory, TConnector, TField } from '../ui';
import { Droppable, Draggable } from "react-beautiful-dnd";
import { colorTheme } from '../ColorTheme';
import UIDefinition from './UIDefinition';


type WorkSpaceProps = {
    formData: any;
    activeTabIndex: number;
    uiModelProjectData?: any;
    setUiModelProjectData: React.Dispatch<React.SetStateAction<any>>;
    setEditFlag? : any;
    setEditField?: any;
    setSubmodelEditFlag?: any;
    setEditSubmodel?: any;
    setCategoryEditFlag?: any;
    setEditCategory?: any;
    projectId: string;
}

const WorkSpace = ({formData, setUiModelProjectData, activeTabIndex, setEditFlag, setEditField, setSubmodelEditFlag, setEditSubmodel, setCategoryEditFlag, setEditCategory, projectId}: WorkSpaceProps) => {

    const [uiFormData, setUiFormData] = useState<any>([]);


    useEffect(() => {
        setUiFormData(JSON.parse(JSON.stringify(formData)))
    }, [formData])

   
    const updateField = (uifield: TField, fieldIndex: number, dataModelIndex: number=0) => {
        try{
            setUiModelProjectData((prevUiModel: any) => {
                let updatedPages = [...prevUiModel.pages];
                const updatedDataModels = [...updatedPages[activeTabIndex].formData];
                const dataModelToUpdate = updatedDataModels[dataModelIndex];

                const updatedFields = [...dataModelToUpdate.items];
                updatedFields[fieldIndex] = { ...updatedFields[fieldIndex], ...uifield, };

                const updatedDataModel = { ...dataModelToUpdate, items: updatedFields,};
                updatedDataModels[dataModelIndex] = updatedDataModel;
                updatedPages[activeTabIndex] = { ...updatedPages[activeTabIndex], formData: updatedDataModels };

                //updatedPages = JSON.parse(JSON.stringify(updatedPages))
                

                return { ...prevUiModel, pages: updatedPages };
            });
        }
        catch(e){
            console.error(e)
        }
    }

    const updateCategory = (uiCategory: TCategory, categoryIndex: number, dataModelIndex: number=0) => {
        try{
            setUiModelProjectData((prevUiModel: any) => {
                const updatedPages = [...prevUiModel.pages];
                const updatedDataModels = [...updatedPages[activeTabIndex].formData];
                const dataModelToUpdate = updatedDataModels[dataModelIndex];

                const updatedCategories = [...dataModelToUpdate.items];
                updatedCategories[categoryIndex] = { ...updatedCategories[categoryIndex], ...uiCategory, };

                const updatedDataModel = { ...dataModelToUpdate, items: updatedCategories,};
                updatedDataModels[dataModelIndex] = updatedDataModel;
                updatedPages[activeTabIndex] = { ...updatedPages[activeTabIndex], formData: updatedDataModels };
                
                return { ...prevUiModel, pages: updatedPages };
            });
        }
        catch(e){
            console.error(e)
        }
    };

    const updateConnector = (uiConnector: TConnector, connectorIndex: number, dataModelIndex: number=0) => {
        try{
            setUiModelProjectData((prevUiModel: any) => {
                const updatedPages = [...prevUiModel.pages];
                const updatedDataModels = [...updatedPages[activeTabIndex].formData];
                const dataModelToUpdate = updatedDataModels[dataModelIndex];

                const updatedConnectors = [...dataModelToUpdate.items];
                updatedConnectors[connectorIndex] = { ...updatedConnectors[connectorIndex], ...uiConnector, };

                const updatedDataModel = { ...dataModelToUpdate, items: updatedConnectors,};
                updatedDataModels[dataModelIndex] = updatedDataModel;
                updatedPages[activeTabIndex] = { ...updatedPages[activeTabIndex], formData: updatedDataModels };

                return { ...prevUiModel, pages: updatedPages };
            });
        }
        catch(e){
            console.log(e)
        }
    };

    const deleteField = (fieldIndex: number, dataModelIndex: number=0) => {
        setUiModelProjectData((prevUiModel: any) => {
            const updatedPages = [...prevUiModel.pages];
            const updatedDataModels = [...updatedPages[activeTabIndex].formData];
            const dataModelToUpdate = updatedDataModels[dataModelIndex];
    
            // Delete from items array instead of fields
            const updatedFields = [...dataModelToUpdate.items];
            updatedFields.splice(fieldIndex, 1);
    
            const updatedDataModel = { ...dataModelToUpdate, items: updatedFields };
            updatedDataModels[dataModelIndex] = updatedDataModel;
            updatedPages[activeTabIndex] = { 
                ...updatedPages[activeTabIndex], 
                formData: updatedDataModels 
            };
    
            return { ...prevUiModel, pages: updatedPages };
        });
    };

    const deleteDataModel = (dataModelIndex: number) => {
        setUiModelProjectData((prevUiModel: any) => {
            const updatedPages = [...prevUiModel.pages];
            const updatedDataModels = [...updatedPages[activeTabIndex].formData];
            updatedDataModels.splice(dataModelIndex, 1);
            updatedPages[activeTabIndex] = { ...updatedPages[activeTabIndex], formData: updatedDataModels };
            return { ...prevUiModel, pages: updatedPages };
        });
    };

    return (
        <div>
            <Droppable droppableId="form_droppable" type="controls">
                {(provided, snapshot) => (
                    <div className=''>
                    {formData.length > 0 ? 
                        <ul style={{
                                backgroundColor: colorTheme.background,
                                //border: 'dotted',
                                width: '100%',
                                overflow: 'auto',
                                marginTop: '0px',
                                minHeight: '400px',
                                background: snapshot.isDraggingOver ? "lightblue" : "white",
                            }}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {uiFormData.map((data: any, index: any) => (
                            <Draggable
                                key={`form_draggable_${index}`}
                                draggableId={`form_draggable_${index}`}
                                index={index}
                            >
                                {(provided, snapshot) => (
                                <li
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    className="bg-slate-200 tw-relative"
                                >
                                    <UIDefinition 
                                        submodel={data} 
                                        modelIndex={index} 
                                        updateCategory={updateCategory} 
                                        updateField={updateField} 
                                        updateConnector={updateConnector} 
                                        deleteField={deleteField} 
                                        deleteDataModel={deleteDataModel} 
                                        dragHandleProps = {provided.dragHandleProps}
                                        setEditFlag = {setEditFlag}
                                        setEditField = {setEditField}
                                        setSubmodelEditFlag={setSubmodelEditFlag}
                                        setEditSubmodel= {setEditSubmodel}
                                        setCategoryEditFlag= {setCategoryEditFlag}
                                        setEditCategory= {setEditCategory}
                                        projectId={projectId}
                                    />
                                </li>
                                )}
                            </Draggable>
                            ))}
                            {provided.placeholder}
                        </ul>
                        :
                        <div className="tw-flex tw-flex-col tw-h-full tw-justify-center tw-items-center tw-space-y-4 tw-my-[20%]" {...provided.droppableProps} ref={provided.innerRef}>
                            <div className="tw-w-[124px] tw-h-[124px] tw-bg-zinc-300 tw-rounded-full"></div>
                            <div className="tw-w-[273px] tw-text-center tw-text-slate-900 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-relaxed">Drag and drop submodel, field or widget to the container</div>
                        </div>
                    }
                    </div>
                )}
            </Droppable>
        </div>
    );
};

export default WorkSpace;